import { FirebaseApp } from '@castiron/castiron-firebase';
import {
  CustomerRepository,
  ProductRepository,
  TransactionRepository,
  ShopRepository,
  AccountRepository,
  CouponRepository,
  MarketingSendRepository,
  ProductTemplateRepository,
  TierRepository,
  PlanRepository,
  AssetRepository,
  PresaleRepository,
  SessionRepository,
  SpecialRepository,
  SendLogRepository,
  ScheduledMessageRepository,
  MarketplaceIdentifier,
} from '@castiron/domain';

const db = FirebaseApp.firestore();

const marketplace = process.env.REACT_APP_MARKETPLACE_ID as MarketplaceIdentifier;

export const couponRepository = new CouponRepository(db);
export const customerRepository = new CustomerRepository(db);
export const productRepository = new ProductRepository(db);
export const productTemplateRepository = new ProductTemplateRepository(db);
export const transactionRepository = new TransactionRepository(db);
export const shopRepository = new ShopRepository(db, marketplace);
export const accountRepository = new AccountRepository(db);
export const marketingSendRepository = new MarketingSendRepository(db);
export const tierRepository = new TierRepository(db);
export const planRepository = new PlanRepository(db);
export const assetRepository = new AssetRepository(db);
export const presaleRepository = new PresaleRepository(db);
export const sessionRepository = new SessionRepository(db);
export const specialRepository = new SpecialRepository(db);
export const sendLogRepository = new SendLogRepository(db);
export const scheduledMessagesRepository = new ScheduledMessageRepository(db);
